// extracted by mini-css-extract-plugin
export default {"staffs":"index_staffs__9fjto","formWrap":"index_formWrap__GrbFg","radio":"index_radio__xZd0d","del":"index_del__7zhrP"};